import { makeActionCreator } from 'crazyEditor/redux/helpers';

export const SET_ELEMENT_UPDATE_PREVIEW = 'crazyEditor/element/SET_ELEMENT_UPDATE_PREVIEW';
export const CLEAR_ELEMENT_UPDATE_PREVIEW = 'crazyEditor/element/CLEAR_ELEMENT_UPDATE_PREVIEW';
export const APPLY_ELEMENT_UPDATE_PREVIEW = 'crazyEditor/element/APPLY_ELEMENT_UPDATE_PREVIEW';

export function setElementUpdatePreview(ids, elementProps = {}) {
  return {type: SET_ELEMENT_UPDATE_PREVIEW, ids, elementProps};
}

export const clearElementUpdatePreview = makeActionCreator(CLEAR_ELEMENT_UPDATE_PREVIEW);
export const applyElementUpdatePreview = makeActionCreator(APPLY_ELEMENT_UPDATE_PREVIEW);

